import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const isProgressiveAuthEnabled = () => growthAcquisitionExperiments.get('enableProgressiveAuthRollout');

export const shouldShowProgressiveAuth = ({
  shouldDisableProgressiveAuth,
}: {
  shouldDisableProgressiveAuth: boolean;
}) => !shouldDisableProgressiveAuth && isProgressiveAuthEnabled();
